const DELIVERY_ADDRESS_VIEW_PREFIX = "dav";

export const DELIVERY_ADDRESS_VIEW_TEST_IDS = {
    OUTLET_ICON: `${DELIVERY_ADDRESS_VIEW_PREFIX}_outlet_icon`,
    LINK_ICON: `${DELIVERY_ADDRESS_VIEW_PREFIX}_link_icon`,
    CUSTOMER_ADDRESS_ICON: `${DELIVERY_ADDRESS_VIEW_PREFIX}_addr_icon`,
    OUTLET_NAME: `${DELIVERY_ADDRESS_VIEW_PREFIX}_outlet_name`,
    ORDER_DETAILS: `${DELIVERY_ADDRESS_VIEW_PREFIX}_order_dtls`,
    ADDRESS_ANNOTATION: `${DELIVERY_ADDRESS_VIEW_PREFIX}_addr_tag`,
    ADDRESS_DETAILS: `${DELIVERY_ADDRESS_VIEW_PREFIX}_addr_dtls`,
};
